import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'

export const useSafePush = () => {
  const router = useRouter()
  const [onChanging, setOnChanging] = useState(false)

  const handleRouteChange = useCallback(() => {
    setOnChanging(false)
  }, [])

  // safePush is used to avoid route pushing errors when users click multiple times or when the network is slow:  "Error: Abort fetching component for route"
  const safePush = useCallback((path: string) => {
    if (onChanging) {
      return
    }
    setOnChanging(true)
    router.push(path)
  }, [])

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router, setOnChanging])

  return { safePush }
}
